import { render, staticRenderFns } from "./fixPrice.vue?vue&type=template&id=3c964d18&scoped=true&"
import script from "./fixPrice.vue?vue&type=script&lang=js&"
export * from "./fixPrice.vue?vue&type=script&lang=js&"
import style0 from "./fixPrice.vue?vue&type=style&index=0&id=3c964d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c964d18",
  null
  
)

export default component.exports